module.exports = __webpack_public_path__ + "static/media/logo-r.217f8b4f.svg";